import React from 'react';
import { UnifiedThemeProvider, themes as themes$1 } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';

const themes = [
  {
    id: "light",
    title: "Light Theme",
    variant: "light",
    icon: /* @__PURE__ */ React.createElement(LightIcon, null),
    Provider: ({ children }) => /* @__PURE__ */ React.createElement(UnifiedThemeProvider, { theme: themes$1.light, children })
  },
  {
    id: "dark",
    title: "Dark Theme",
    variant: "dark",
    icon: /* @__PURE__ */ React.createElement(DarkIcon, null),
    Provider: ({ children }) => /* @__PURE__ */ React.createElement(UnifiedThemeProvider, { theme: themes$1.dark, children })
  }
];

export { themes };
//# sourceMappingURL=themes.esm.js.map
